// Import styles
import './assets/styles/reset.scss'
import './assets/main.css'

// Import Vue core
import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Import app components
import App from './App.vue'
import router from './router'

// Create app instance
const app = createApp(App)

// Use plugins
app.use(createPinia())
app.use(router)

// Mount app
app.mount('#app')
